import mammoth from "mammoth";

export interface ExtractedJDContent {
  text: string;
  fileName: string;
  fileSize: number;
}

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const extractTextFromFile = async (file: File): Promise<ExtractedJDContent> => {
  if (file.size > MAX_FILE_SIZE) {
    throw new Error(`File size exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB limit`);
  }

  const fileType = file.type.toLowerCase();
  const fileName = file.name.toLowerCase();

  try {
    if (
      fileType === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
      fileName.endsWith(".docx")
    ) {
      return await extractTextFromDOCX(file);
    } else {
      throw new Error("Unsupported file format. Please upload DOCX files only.");
    }
  } catch (error) {
    console.error("Error extracting text from file:", error);
    throw new Error(`Failed to extract text from ${file.name}. Please try a different file.`);
  }
};

const extractTextFromDOCX = async (file: File): Promise<ExtractedJDContent> => {
  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  
  if (!result.value.trim()) {
    throw new Error("No text content found in the document");
  }

  return {
    text: result.value,
    fileName: file.name,
    fileSize: file.size,
  };
};

export const validateFileType = (file: File): boolean => {
  const allowedTypes = [
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];
  
  const allowedExtensions = [".docx"];
  const fileName = file.name.toLowerCase();
  
  return (
    allowedTypes.includes(file.type.toLowerCase()) ||
    allowedExtensions.some(ext => fileName.endsWith(ext))
  );
};